import React from 'react';
import { ShieldCheck, Wind, Utensils } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-blue-50" data-id="element-78">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-79">
        <div className="text-center mb-16" data-id="element-80">
          <span className="inline-block py-1 px-3 rounded-full bg-teal-100 text-teal-800 font-semibold text-sm mb-4" data-id="element-81">
            LA SOLUCIÓN NATURAL
          </span>
          <h2 className="text-3xl sm:text-5xl font-bold text-slate-900 mb-6" data-id="element-82">
            El Método "Frío Interno"
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-83">
            Un enfoque natural, diseñado específicamente para mujeres hispanas,
            que aborda los tres pilares clave para recuperar tu descanso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-84">
          {/* Pillar 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-teal-500" data-id="element-85">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-6" data-id="element-86">
              <Utensils className="w-7 h-7 text-teal-600" data-id="element-87" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-88">
              1. Triggers Alimenticios
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-89">
              Identificamos y eliminamos los{' '}
              <strong data-id="element-90">7 triggers alimenticios latinos</strong> más comunes que
              disparan sofocos a las 3AM. No es dieta, es estrategia nocturna.
            </p>
          </div>

          {/* Pillar 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-blue-500" data-id="element-91">
            <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-92">
              <Wind className="w-7 h-7 text-blue-600" data-id="element-93" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-94">
              2. Respiración "Viento Andino"
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-95">
              Una técnica ancestral adaptada que reduce la temperatura corporal
              en segundos usando el poder de tu propia respiración para enfriar
              el sistema nervioso.
            </p>
          </div>

          {/* Pillar 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500" data-id="element-96">
            <div className="w-14 h-14 bg-indigo-100 rounded-full flex items-center justify-center mb-6" data-id="element-97">
              <ShieldCheck className="w-7 h-7 text-indigo-600" data-id="element-98" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-99">
              3. Escudo Frío Nocturno
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-100">
              Una rutina sencilla en cinco pasos antes de dormir que mantiene tu
              temperatura estable durante toda la noche, creando una barrera
              contra el calor.
            </p>
          </div>
        </div>
      </div>
    </section>;
}